// import { TabContainer, ThankyouHeader, ThankyouMessage } from "./Social.styled";
import { TabContainer, ThankyouHeader, ThankyouMessage } from "../../components/SocialCaseTbas/Social.styled";
import thanks from "../../assets/thanks.svg";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import HappyMeterStore from "../../stores/HappyMeter";
const RefundThanks = ({ msg, title, referenceId, serviceID,orderIdRegister=false, }: any) => {
  const navigate = useNavigate();

  // () => navigate('/dashboard')
  useEffect(() => {
    HappyMeterStore.setUpTranctionId(referenceId);
    HappyMeterStore.setUPserviceID(serviceID);
    HappyMeterStore.openHappinessMeter();
    localStorage.removeItem('value');
  }, []);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const backButtonHandler = () => {
    HappyMeterStore.openHappinessMeter();
    localStorage.removeItem("value");
    localStorage.removeItem("movein");
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          alignSelf: "flex-start",
          marginTop: "5px",
        }}

      >
        <ThankyouHeader style={{background:contrast?.contrastBackground?contrast?.contrastBackground:'#e0eedc'}}>
          <img src={thanks} alt="" />
          <h1 style={{
            margin: "0", marginBottom: "13px", fontFamily: 'Segoe UI',
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: `${2.125 * General.accessibility.fontSize}rem`,
            lineHeight: "130%",
            color: contrast?.contrastColor ? contrast?.contrastColor: ColorAss
          }}>

            {General?.codeLabels["cm_thankyou"]?.label !== undefined ? General?.codeLabels["cm_thankyou"]?.label : "Thank You"}

          </h1>
        </ThankyouHeader>
        <ThankyouMessage>
          <p style={{
            padding: "0",
            margin: "0",
            marginTop: "20px",
            marginBottom: "20px",
            fontSize: `${General.accessibility.fontSize}rem`,
            fontWeight: "700",
            color: contrast?.contrastColor ? contrast?.contrastColor: ColorAss 
          }}>
            {title ? title : "Social Case Application"} 
          </p>
          <ButtonSecondary  onClick={()=>navigate('/dashboard')} 
          style={{ 
            height: "50px", 
            width: "252px", 
            fontFamily: "Segoe UI", 
            fontWeight: "700", 
            fontSize: `${General.accessibility.fontSize}rem`, 
            lineHeight: "130%",
            color: contrast?.contrastBackground?contrast?.contrastBackground:"#fff", 
            background: contrast?.contrastColor?contrast?.contrastColor:ColorAss,
            border:'none' }}>
          {General?.codeLabels["cm_back_to_dassh"]?.label?General?.codeLabels["cm_back_to_dassh"]?.label:'BACK TO DASHBOARD'}
          </ButtonSecondary>
        </ThankyouMessage>
      </div>
    </>
  );
};

export default observer(RefundThanks);
